module.exports = __webpack_public_path__ + "img/toqoo-logo.6afa37d4.png";